import { CircularProgress } from '@mui/material';
import { Theme } from '@mui/material/styles/createTheme';
import { SxProps } from '@mui/system/styleFunctionSx';
import React from 'react';

type Props = {
  size?: number;
  sx?: SxProps<Theme>;
};

export const Spinner = ({ size = 60, sx }: Props) => (
  <CircularProgress size={size} sx={{ padding: '0 !important', ...sx }} />
);
